import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error Untyped module
import ResolveReferences from 'reference-resolvers/ResolveReferences';
import { IN_RANGE, LESS } from '../constants/FilterOperatorTypes';
// @ts-expect-error Untyped module
import { isResolved } from 'reference-resolvers/utils';
import useContentPlatformPropertiesConfiguration from '../hooks/useContentPlatformPropertiesConfiguration';
import { getPropertyLabel } from '../utils/propertyUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const langKey = 'content-management-listing-lib.filterTagsBar';
export const FilterTagDescriptorLabel = ({
  property
}) => {
  const {
    propertyDefinitionMap
  } = useContentPlatformPropertiesConfiguration();
  const propertyLabel = getPropertyLabel(propertyDefinitionMap, property);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: `${langKey}.descriptors.hs_custom_property`,
      options: {
        propertyLabel
      }
    }), "\xA0"]
  });
};
export const FilterTagDateLabel = ({
  filter
}) => {
  const {
    operator,
    value,
    highValue
  } = filter;
  const options = {
    // @ts-expect-error untyped portalTz on moment
    date: I18n.moment.portalTz(value).format('ll')
  };
  const dateFormatKey = `${langKey}.dateFormats`;
  let messageKey = `${dateFormatKey}.between`;
  if (operator === IN_RANGE) {
    // @ts-expect-error untyped portalTz on moment
    options.highDate = I18n.moment.portalTz(highValue).format('ll');
  } else if (operator === LESS) {
    messageKey = `${dateFormatKey}.before`;
  } else {
    messageKey = `${dateFormatKey}.after`;
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: messageKey,
    options: options
  });
};
const provideReference = ResolveReferences((resolvers, {
  type,
  id
}) => {
  const resolver = resolvers[type];
  return {
    reference: resolver.byId(String(id))
  };
});
const FilterTagEnumerationLabel = ({
  reference,
  id,
  shouldShowLanguage
}) => {
  if (isResolved(reference)) {
    const language = reference.getIn(['referencedObject', 'language']);
    return shouldShowLanguage && language ? `${reference.label} (${I18n.text(`SharedI18nStrings.languageNames.${language}`)})` : reference.label;
  }
  return id;
};
export const FilterTagEnumLabel = provideReference(FilterTagEnumerationLabel);